module.exports = __webpack_public_path__ + "img/member_list.e20c3dca.png";